import type { FragmentOf } from '@/utilities/gql';
import { Button } from '@simplywallst/ui-core/next';
import EditSolid from '@simplywallst/ui-core/icons/EditSolid';
import { useTracking } from 'react-tracking';
import type { ComponentProps } from 'react';
import type { NARRATIVE_EDIT_BUTTON_FRAGMENT } from './narrativeEditButtonFragment';
import { useNarrativeEditLink } from './hooks/useNarrativeEditLink';

type Props = {
  narrative: FragmentOf<typeof NARRATIVE_EDIT_BUTTON_FRAGMENT>;
  returnPath?: string;
  size?: ComponentProps<typeof Button>['size'];
};

export const NarrativeEditButton = ({
  narrative,
  returnPath,
  size = 'large',
}: Props) => {
  const { trackEvent } = useTracking();

  const { editHref } = useNarrativeEditLink({
    narrative,
    companyId: narrative.companyId,
    returnPath,
  });

  if (!editHref) return null;

  return (
    <Button
      variant="outline"
      size={size}
      href={editHref}
      className="text-center"
      onClick={() => {
        trackEvent({
          action: 'click',
          target: 'edit-narrative',
          valuationType: 'user_defined',
        });
      }}
    >
      <EditSolid className="!mr-1" />
      Edit
    </Button>
  );
};
